import { createApp } from 'vue'
import SalaryToHourly from './SalaryToHourly.vue'
import './assets/global.css'

createApp(SalaryToHourly).mount('#salary-to-hourly')
